export class producto_impuesto {
    empresa_rut: number;
    producto_codigo: number;
    impuesto_codigo: number;
    fecha_registro: Date;
}